module.exports = __webpack_public_path__ + "img/pagoBBVAcompleto.b54bc1ac.png";